import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import StyledBox from 'views/experience-module/MotorcycleTripView/components/ComparisonSection/ComparisonSection.styles';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  Tabs,
  Tab,
  Box,
  Container,
} from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500/Typography500';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import SelfGuidedToursWhite from 'views/common/components/UI/Icons/SelfGuidedToursWhite';
import { ImgBox } from 'views/common/components';
import useGetComparisonSection from 'views/experience-module/MotorcycleTripView/hooks/useGetComparisonSection';
import { TABS_VALUE_MAP } from 'views/experience-module/MotorcycleTripView/utils/Constants';

const ComparisonSection = (props) => {
  const {
    tripName, trips, tripImg, hanleBookNowBtnClick,
  } = props;

  const { t } = useTranslation('fe_er_motorcycle_trip_page');
  const [selectedTab, setSelectedTab] = useState(1);
  const [getTourInclusions, getTourInclusionsTabs] = useGetComparisonSection();
  const handleTabClick = (e, value) => {
    setSelectedTab(value);
  };
  const renderPanelContent = (title, panelPrice, testId) => (
    <>
      <Box className="CMStopSection">
        <Typography500 variant="h3" component="p" mb={1.5}>
          {title}
        </Typography500>
        <Typography
          variant="body2"
          component="p"
          mb={1.5}
          className="CMSStarting">
          {t('fe_er_motorcycle_trip_page:starting')}
        </Typography>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography500 variant="h1" component="p" color="primary">
              {`${panelPrice}/${t('fe_er_motorcycle_trip_page:day')}`}
            </Typography500>
          </Grid>
          <Grid item>
            <Button
              data-testid={testId}
              onClick={() => {
                hanleBookNowBtnClick(title);
              }}
              variant="contained"
              color="primary">
              {t('fe_er_motorcycle_trip_page:book_now')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
  const tabPanels = {
    1: renderPanelContent(
      t('fe_er_motorcycle_trip_page:bike_only'),
      t('fe_er_motorcycle_trip_page:start_bike_only').split('/')[0],
    ),
    2: renderPanelContent(
      t('fe_er_motorcycle_trip_page:self_drive'),
      t('fe_er_motorcycle_trip_page:start_self_drive').split('/')[0],
    ),
    3: renderPanelContent(
      t('fe_er_motorcycle_trip_page:guided'),
      t('fe_er_motorcycle_trip_page:start_guided').split('/')[0],
    ),
  };
  return (
    <StyledBox position="relative">
      <Container maxWidth="xl">
        <Grid container columnSpacing={3}>
          <Grid item lg={3} md={0} className="showDESKTOP">
            <Box className="showDESKTOP CSimg">
              <ImgBox
                image={{
                  src: tripImg,
                  alt: 'motorcycleTrip',
                }}
                imgHeight="100%"
              />
              <Box className="CSoverlayColor">
                <Box>
                  <SelfGuidedToursWhite className="CSIcon" />
                  <Typography500 component="p" variant="h3" my={1}>
                    {t('fe_er_motorcycle_trip_page:starting')}
                  </Typography500>
                  <Typography500 component="p" variant="h1">
                    {`${
                      t('fe_er_motorcycle_trip_page:start_bike_only').split(
                        '/',
                      )[0]
                    } / ${t('fe_er_motorcycle_trip_page:day')}`}
                  </Typography500>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item lg={9} xs={12}>
            <Box className="CStitle">
              <Typography500 variant="h3" component="h2">
                {t('fe_er_motorcycle_trip_page:ways_to_explore', {
                  page_name: tripName,
                })}
              </Typography500>
              <Typography variant="body2" component="p">
                {t('fe_er_motorcycle_trip_page:many_ways_to_experience', {
                  page_name: tripName,
                })}
              </Typography>
            </Box>
            <Box className="showTABLET">
              <Tabs value={selectedTab} onChange={handleTabClick} centered>
                {getTourInclusionsTabs(trips).map((tab) => (
                  <Tab className="CMStab" key={tab.value} {...tab} />
                ))}
              </Tabs>
              <Box pt={3}>{tabPanels[selectedTab]}</Box>
            </Box>
            <TableContainer className="CSTableContainer">
              <Table size="small">
                <TableHead className="showDESKTOP">
                  <TableRow>
                    <TableCell />
                    {getTourInclusionsTabs(trips).map((item) => (
                      <TableCell
                        key={item.value}
                        align="center"
                        className={`${
                          selectedTab !== item.value && 'CSHiddencell'
                        }`}>
                        {item.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getTourInclusions(trips).map((tour) => (
                    <TableRow key={tour.inclusion}>
                      <TableCell component="th" scope="row">
                        {tour.inclusion}
                      </TableCell>
                      {getTourInclusionsTabs(trips).map((tab) => (
                        <TableCell
                          key={tab.value}
                          align="center"
                          className={`${
                            selectedTab !== tab.value && 'CSHiddencell'
                          }`}>
                          {tour[TABS_VALUE_MAP[tab.value]] ? (
                            <CheckIcon className="CSCheckIcon" />
                          ) : (
                            <RemoveIcon className="CSdiabledCheck" />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  <TableRow className="showDESKTOP">
                    <TableCell component="th" scope="row" />
                    {getTourInclusionsTabs(trips).map((item) => (
                      <TableCell align="center" key={item.value}>
                        <Typography
                          component="p"
                          variant="caption"
                          className="CSStartingAtText">
                          {t('fe_er_motorcycle_trip_page:starting')}
                        </Typography>
                        <Typography500
                          component="p"
                          variant="h5"
                          className="CSBookPrice">
                          {item.price}
                        </Typography500>
                        <Button
                          data-testid={`experience-book-now-${item.value}`}
                          onClick={() => {
                            hanleBookNowBtnClick(item.label);
                          }}
                          variant="contained"
                          color="primary">
                          {t('fe_er_motorcycle_trip_page:book_now')}
                        </Button>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { ComparisonSection };
